import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Typography,
} from "@material-tailwind/react";

import {
  GlobeAltIcon,
  ChevronRightIcon,
  CheckIcon,
} from "@heroicons/react/24/solid";

import { useDispatch, useSelector } from "react-redux";
import React, { Fragment, useEffect } from "react";

import ShowLoader from "@/components/Loader";

import {
  getCurrencies,
  setSelectedCurrency,
  initializeSelectedCurrency,
} from "@/store/slices/currentCountrySlice";

import {
  getUserProfile,
  updateProfile,
} from "@/store/slices/userSlice";

const CountrySubMenu = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();

  const {
    currencies,
    selectedCurrency,
    loading: currencyLoading,
  } = useSelector((state) => state.currentCurrency);

  const {
    user,
    loading: userLoading,
  } = useSelector((state) => state.user);

  /**
   * Load currencies
   */
  useEffect(() => {
    // if (!currencies?.length) {
      dispatch(getCurrencies());
    // }

    dispatch(initializeSelectedCurrency());
  }, [dispatch, currencies?.length]);

  /**
   * If user has currency_code,
   * select that currency.
   */
  useEffect(() => {
    if (!currencies?.length || !user?.currency_code) return;

    const userCurrency = currencies.find(
      (currency) =>
        currency.currency_code === user.currency_code
    );

    if (userCurrency) {
      dispatch(setSelectedCurrency(userCurrency));
    }
  }, [currencies, user?.currency_code, dispatch]);

  /**
   * Change country/currency
   */
  const changeCountry = async (currency) => {
    if (!currency) return;

    /**
     * Don't do anything if already selected
     */
    if (
      selectedCurrency?.currency_code === currency.currency_code
    ) {
      return;
    }

    try {
      /**
       * 1. Update Redux
       */
      dispatch(setSelectedCurrency(currency));

      /**
       * 2. Save locally
       */
      localStorage.setItem(
        "selected_currency",
        JSON.stringify(currency)
      );

      /**
       * 3. Update admin user's currency
       */
      if (user?.id) {
        const payload = {
          id: user.id,
          first_name: user.first_name,
          email: user.email,
          role: user?.roles?.[0],

          currency_code: currency.currency_code,
        };

        const res = await dispatch(
          updateProfile(payload)
        ).unwrap();

        console.log("Currency update response:", res);

        /**
         * 4. Refresh user profile
         */
        if (res?.status) {
          dispatch(getUserProfile());

          /**
           * Notify other components
           */
          // window.dispatchEvent(
          //   new Event("currencyChanged")
          // );

          /**
           * Optional:
           * reload admin panel so all
           * currency-dependent data refreshes
           */
          window.location.reload();
        }
      }
    } catch (error) {
      console.error(
        "Country change failed:",
        error
      );
    }
  };

  const loading = currencyLoading || userLoading;

  return (
    <Fragment>
      <Menu placement="right-start" allowHover>

        {loading && <ShowLoader />}

        <MenuHandler>
          <MenuItem
            {...props}
            ref={ref}
            className="flex items-center justify-between"
          >
            <div className="flex items-center gap-3">

              <GlobeAltIcon className="h-5 w-5" />

              <Typography
                variant="small"
                className="font-semibold"
              >
                {currencies.find(
                  (currency) => currency.currency_code === selectedCurrency?.currency_code
                )?.country_name || "Country"}
              </Typography>

            </div>

            <ChevronRightIcon className="h-4 w-4" />

          </MenuItem>
        </MenuHandler>

        <MenuList className="min-w-[260px] max-h-[350px] overflow-y-auto">

          {currencies?.map((currency) => (

            <MenuItem
              key={currency.id}
              onClick={() =>
                changeCountry(currency)
              }
              className="flex items-center justify-between gap-3"
            >

              <div className="flex items-center gap-3">

                <span className="text-xl">
                  {currency.flag || "🌍"}
                </span>

                <div>
                  <Typography
                    variant="small"
                    className="font-medium"
                  >
                    {currency.country_name}
                  </Typography>

                  <Typography
                    variant="small"
                    className="text-xs text-gray-500"
                  >
                    {currency.currency_code} -{" "}
                    {currency.currency_name}
                  </Typography>
                </div>

              </div>

              {selectedCurrency?.currency_code ===
                currency.currency_code && (
                <CheckIcon className="h-4 w-4 text-green-600" />
              )}

            </MenuItem>

          ))}

        </MenuList>

      </Menu>
    </Fragment>
  );
});

export default CountrySubMenu;